import "./assets/css/index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import Services from "./components/pages/Services";
import OurClient from "./components/pages/OurClient";
import WhatsappIcon from "./components/whatsappIcon/WhatsappIcon";
import ScrollToTop from "./components/pages/ScrollToTop";

function App() {
  return (
    <div >
      <WhatsappIcon />
      <BrowserRouter>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/client" element={<OurClient />} />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </div>
  );
}

export default App;
